{
  "All milestones completed!": "All milestones completed!",
  "All of your tasks are awaiting their scheduled dates": "All of your tasks are awaiting their scheduled dates",
  "Complete Tasks Now": "Complete Tasks Now",
  "Complete your first task to get started!": "Complete your first task to get started!",
  "Completed": "Completed",
  "Failed to skip tasks. Please try again later.": "Failed to skip tasks. Please try again later.",
  "Finish setting up Weave by completing the tasks below": "Finish setting up Weave by completing the tasks below",
  "First:": "First:",
  "Go to Dashboard": "Go to Dashboard",
  "Next:": "Next:",
  "Not Started": "Not Started",
  "Not started": "Not started",
  "Onboarding tasks skipped successfully.": "Onboarding tasks skipped successfully.",
  "Ready to keep going? Check out Weave Training Camp to learn everything Weave has to offer!": "Ready to keep going? Check out Weave Training Camp to learn everything Weave has to offer!",
  "Skip Remaining": "Skip Remaining",
  "Some locations have incomplete tasks": "Some locations have incomplete tasks",
  "Upcoming Dates": "Upcoming Dates",
  "View All": "View All",
  "Weave Training Camp": "Weave Training Camp",
  "Welcome to Weave!": "Welcome to Weave!",
  "You're all set for now!": "You're all set for now!",
  "You've completed all the milestones!": "You've completed all the milestones!",
  "{{completed}} / {{total}} milestones completed": "{{completed}} / {{total}} milestones completed",
  "{{completed}} / {{total}} tasks completed": "{{completed}} / {{total}} tasks completed",
  "{{count}} Numbers Porting_one": "Numbers Porting",
  "{{count}} Numbers Porting_other": "{{count}} Numbers Porting",
  "{{count}} Onboarding Call_one": "Onboarding Call",
  "{{count}} Onboarding Call_other": "{{count}} Onboarding Call",
  "{{count}} Phones Shipped_one": "Phones Shipped",
  "{{count}} Phones Shipped_other": "{{count}} Phones Shipped",
  "{{taskName}} first": "{{taskName}} first"
}
